import React from 'react'
import { Navigate } from 'react-router-dom'
import { useUser } from 'store'

interface RouteGuardProps {
  children: React.ReactNode
  requiredRoles?: string[]
  requireAdmin?: boolean
  redirectTo?: string
}

const RouteGuard: React.FC<RouteGuardProps> = ({ 
  children, 
  requiredRoles = [], 
  requireAdmin = false,
  redirectTo = '/dashboard' 
}) => {
  const [user] = useUser()

  if (!user) {
    return <Navigate to="/auth/login" replace />
  }

  if (user.admin) {
    return <>{children}</>
  }

  if (requireAdmin) {
    return <Navigate to={redirectTo} replace />
  }

  if (requiredRoles.length === 0) {
    return <>{children}</>
  }

  const hasRequiredRole = requiredRoles.some(role => user.roles?.[role])

  if (!hasRequiredRole) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}

export default RouteGuard